import { useUnreadMessageCountStore } from "@/store/unreadMessageCountStore";

export const useUnreadMessageCount = () => {
  const unreadMessageCount = useUnreadMessageCountStore(s => s.count);

  return {
    unreadMessageCount,
  };
};
